import { AccountingOpenPostPostingsService_openPostPostingsServiceGetQuery } from '@festina/moneyout-general-types/moneyout/hooks/AccountingOpenPostPostingsService_openPostPostingsServiceGetQuery'

export const useFetchMoneyOutPosting =
  AccountingOpenPostPostingsService_openPostPostingsServiceGetQuery.useSuspenseQuery
